export const APP_STORE_LINKS = {
    appStore: process.env.REACT_APP_APP_STORE_URL || 'https://apps.apple.com/ng/app/vocalcentric/id6739209305',
    playStore: process.env.REACT_APP_PLAY_STORE_URL || 'https://play.google.com/store/apps/details?id=com.vocalcentric.mobile&pcampaignid=web_share',
};

export default APP_STORE_LINKS;
